import { atom } from 'recoil';

export const hoveredElementState = atom({
    key: 'hoveredElement',
    default: '',
});
